export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Baixe o app TeuCard e peça o cartão direto do celular",
  description:
    "Rápido, seguro e com todas as vantagens para você aproveitar o cartão que mais cresce na região.",
  buttonLabel: "INSTALAR APP TEUCARD",
  imgStart: "",
  img: "",
  alt: "",
  start: "",
};
